module.exports = __webpack_public_path__ + "static/media/Lightbulb.271b348f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Lightbulb.svg
// module id = 301
// module chunks = 0